import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  deChatHealthInformationCopilotQuery as deChatHealthInformationCopilotQueryType,
  deChatHealthInformationCopilotQuery$data,
} from "@/modules/chats/services/ai/de/__generated__/deChatHealthInformationCopilotQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query deChatHealthInformationCopilotQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    chatHealthInformationCopilot: de_chatHealthInformationCopilot(aiRequestMetadata: $aiRequestMetadata) {
      healthInformation {
        allergies {
          diagnosis {
            diagnosisCode
            text
          }
          comment
        }
        conditions {
          diagnosisCode
          text
        }
        medications
      }
      result
    }
  }
`

export const deChatHealthInformationCopilotQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<deChatHealthInformationCopilotQueryType>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}

export type DeHealthInformationCopilot = NonNullable<
  deChatHealthInformationCopilotQuery$data["chatHealthInformationCopilot"]["healthInformation"]
>
